import { useState } from 'react';
import { Search, RefreshCw, Loader2 } from 'lucide-react';
import { useSessions } from '../hooks/useSessions';
import { SessionListItem } from '../components/SessionListItem';

const STATUS_FILTERS: Array<{ value: string; label: string }> = [
  { value: '', label: 'Todas' },
  { value: 'active', label: 'Ativas' },
  { value: 'stopped', label: 'Paradas' },
  { value: 'archived', label: 'Arquivadas' },
  { value: 'error', label: 'Com erro' },
];

export function SessionsPage() {
  const [status, setStatus] = useState('');
  const [q, setQ] = useState('');
  const [qDebounced, setQDebounced] = useState('');

  const { sessions, total, loading, error, reload } = useSessions({
    status: status || undefined,
    q: qDebounced || undefined,
  });

  // Debounce simples para input de busca
  if (q !== qDebounced) {
    setTimeout(() => setQDebounced(q), 200);
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h1 className="text-xl font-semibold">Sessões</h1>
          <p className="text-xs text-text-muted mt-0.5">
            {loading ? 'Carregando…' : `${total} sessão(ões)`}
          </p>
        </div>
        <button type="button" onClick={reload} className="btn">
          <RefreshCw size={14} className={loading ? 'animate-spin' : ''} />
          Recarregar
        </button>
      </div>

      <div className="flex items-center gap-2 mb-4 flex-wrap">
        <div className="relative flex-1 min-w-[200px]">
          <Search
            size={14}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-text-subtle pointer-events-none"
          />
          <input
            type="text"
            placeholder="Buscar por id, spec, repo…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            className="input w-full pl-8"
          />
        </div>

        <div className="flex items-center gap-1 flex-wrap">
          {STATUS_FILTERS.map((f) => (
            <button
              key={f.value || 'all'}
              type="button"
              onClick={() => setStatus(f.value)}
              className={`px-3 py-1.5 rounded text-xs font-medium border transition-colors ${
                status === f.value
                  ? 'bg-blue-600 border-blue-500 text-white'
                  : 'bg-bg-card border-border hover:border-border-light'
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>
      </div>

      {error && (
        <div className="card border-red-300 bg-red-50 text-red-700 text-sm mb-4">
          {error}
        </div>
      )}

      {loading && sessions.length === 0 ? (
        <div className="flex items-center justify-center py-12 text-text-muted">
          <Loader2 size={20} className="animate-spin mr-2" /> Carregando sessões…
        </div>
      ) : sessions.length === 0 ? (
        <div className="card text-center text-text-muted py-12">
          Nenhuma sessão encontrada com os filtros atuais.
        </div>
      ) : (
        <div className="space-y-2">
          {sessions.map((s) => (
            <SessionListItem key={s.sessionId} session={s} />
          ))}
        </div>
      )}
    </div>
  );
}
